module.exports = __webpack_public_path__ + "img/gs.88b7c94a.svg";